import React from 'react';

export default class UserSideNav extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('UserSideNav - render - this.props', this.props);
		return (
			<div className="UserNav">
				<div className="title-container">
					<span className="title">NAVIGATION</span>
				</div>
				<ul className="links-container">
					<li className="link">{this.props.section1}</li>
					<li className="link">{this.props.section2}</li>
					<li className="link">{this.props.section3}</li>
				</ul>
			</div>
		);
	}
}
